import { SharePointResourcesBaseModel } from '../../microsoft/sharepoint/share-point-resources-base-model';

export class SharePointAuditResourcesModel extends SharePointResourcesBaseModel {
  beginDate: Date;
  endDate: Date;
  providerPolicy: string;
}
